import React from 'react';
import OverWindow from '../../../Elements/TabList/OverWindow';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import AssignmentService from '../../../Services/AssignmentService';
import AssignmentSearchParams from '../../Operations/Assignments/AssignmentSearchParams';
import EvaluatorAssignmentItem from '../../../Domain/EvaluatorAssignmentItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

export default class ShowAssignmentListOverDataWindow extends React.Component {
  static defaultProps = {
    evaluator: {},
    clickOnCancel: () => {
      alert('Missing function');
    },
    title: 'Evaluator Assignments'
  };

  constructor(props) {
    super(props);

    this.state = {
      itemList: [],
      selected: -1,
      shownPanel: ShownPanelsEnum.Search,
      searchItem: new AssignmentSearchParams()
    };

    this.state.searchItem.AsEvid = this.props.evaluator.EvSassieId;
    this.state.searchItem.AsCcuid = this.props.evaluator.AsCcuid;
    this.state.searchItem.AsBillClient = this.props.evaluator.AsBillClient;
    this.state.searchItem.AsPayEvaluator = this.props.evaluator.AsPayEvaluator;
  }

  getIdDisplay() {
    let idDisplay = ' (SassieId: ' + this.props.evaluator.EvSassieId + ')';
    if (this.props.evaluator.EvSassieId === undefined) {
      if (this.props.evaluator.AsCcuid !== undefined) {
        idDisplay = ' (Client ID: ' + this.props.evaluator.AsCcuid + ')';
      } else {
        idDisplay = '';
      }
    }
    return idDisplay;
  }

  getDisplayName() {
    let displayName = ' - ' + this.props.evaluator.EvLastName + ', ' + this.props.evaluator.EvFirstName;
    if (this.props.evaluator.EvLastName === undefined && this.props.evaluator.EvFirstName === undefined) {
      displayName = '';
    } else if (this.props.evaluator.EvLastName === undefined) {
      displayName = ' - ' + this.props.evaluator.EvFirstName;
    } else if (this.props.evaluator.EvFirstName === undefined) {
      displayName = ' - ' + this.props.evaluator.EvLastName;
    }
    return displayName;
  }

  renderInfo() {
    return (
      <div className='verticalScroll'>
        <div className='StaticDataTable'>
          <div className='FigmaDataTableBorder'>
            <TabOfDataTable
              type={EvaluatorAssignmentItem}
              shownPanel={this.state.shownPanel}
              serviceFunction={AssignmentService.GetEvaluatorAssignmentList}
              convertDBItemsFunction={AssignmentService.ConvertDBItemListEvaluator}
              searchItem={this.state.searchItem}
              errorCode='SALODW78'
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={this.props.title + this.getDisplayName() + this.getIdDisplay()}
        closeOnClickOutside={false}
        verticalScroll={false}
        bothScroll={true}
      >
        <div className='verticalScroll showassignmentlistheight'>
          <TabOfDataTable
            type={EvaluatorAssignmentItem}
            shownPanel={this.state.shownPanel}
            serviceFunction={AssignmentService.GetEvaluatorAssignmentList}
            convertDBItemsFunction={AssignmentService.ConvertDBItemListEvaluator}
            searchItem={this.state.searchItem}
            errorCode='SALODW95'
          />
        </div>
      </OverWindow>
    );
  }
}
